import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'contribute',
  templateUrl: './contribute.component.html',
  styleUrls: ['./contribute.component.scss']
})
export class ContributeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
